export const filterOptionForLabelAndValueSearch = (
  input: string,
  option:
    | {
        key: string;
        value: string;
        label: string;
      }
    | undefined
) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
  (option?.value ?? "").toLowerCase().includes(input.toLowerCase()) ||
  (option?.key ?? "").toLowerCase().includes(input.toLowerCase());

/** Sort an array of `{ label: string }` options alphabetically by label. */
export const sortByLabel = <T extends { label: string }>(options: T[]): T[] =>
  [...options].sort((a, b) => a.label.localeCompare(b.label));

/** Sort an array of objects alphabetically by a given string key. */
export const sortByKey =
  <T>(key: keyof T) =>
  (items: T[]): T[] =>
    [...items].sort((a, b) => String(a[key]).localeCompare(String(b[key])));
